import { ref } from "vue";
import dayjs from "dayjs";

export function useConvertToUserTimezone() {
  const userTimezone = ref(Intl.DateTimeFormat().resolvedOptions().timeZone);

  /**
   * Converts a UTC time string to the user's local timezone.
   * @param {string} utcTime - The UTC time string in the format 'YYYY-MM-DD HH:mm:ss'.
   * @returns {string} - The converted time in the user's local timezone.
   */
  const convertToUserTimezone = (utcTime) => {
    try {
      if (utcTime) {
        // Convert the input string to an ISO format for Date parsing
        const isoTime = utcTime.replace(" ", "T") + "Z";
        const date = new Date(isoTime); // Parse the UTC time string

        // Use Intl.DateTimeFormat to format the date in the user's local timezone
        const formatter = new Intl.DateTimeFormat("en-US", {
          timeZone: userTimezone.value,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false, // Use 24-hour format
        });
        return dayjs(formatter.format(date)).format("YYYY-MM-DD HH:mm:ss"); // Return the formatted time
      }
    } catch (error) {
      console.error("Error converting time:", error);
      return "Invalid Date";
    }
  };

  return { userTimezone, convertToUserTimezone };
}
